import React from 'react';
import { APPLICATION_NAME } from 'utils';
import FjAvatarMenu from './fj-avatar-menu';
import * as Components from './components';
// Untyped .js/asset import resolves as any — fine.
import HeaderLogo from './public/images/BDAP-logotype-white-8.png';

interface FjAvatarStyle {
  backgroundColor?: string;
  fontColor?: string;
  fontSize?: string;
}

interface RenderMenuArgs {
  onClose: () => void;
}

interface FjGlobalHeaderProps {
  authenticated?: boolean;
  headerText?: string;
  headerLogoPath?: string;
  showAvatar?: boolean;
  logoWidth?: string;
  logoHeight?: string;
  initials?: string;
  fjAvatarStyle?: FjAvatarStyle;
  className?: string;
  renderMenu?: (args: RenderMenuArgs) => React.ReactNode;
  children?: React.ReactNode;
}

class FjGlobalHeader extends React.Component<FjGlobalHeaderProps> {
  static defaultProps = {
    authenticated: false,
    headerLogoPath: HeaderLogo,
    showAvatar: true,
    logoWidth: '255px',
    logoHeight: '',
    initials: '',
    fjAvatarStyle: {},
    className: '',
  };

  renderAvatar = (): React.ReactNode => {
    const { authenticated, fjAvatarStyle, showAvatar, initials, renderMenu } = this.props;

    if (!showAvatar) {
      return null;
    }

    if (authenticated) {
      return (
        <FjAvatarMenu
          authenticated={authenticated}
          initials={initials}
          renderMenu={renderMenu!}
          fjAvatarStyle={fjAvatarStyle}
        />
      );
    }

    return null;
  };

  render(): React.ReactNode {
    const { headerText, headerLogoPath, logoWidth, logoHeight, className, children } = this.props;
    return (
      <Components.Container className={className}>
        <Components.Header>
          <Components.LeftWrapper>
            <a href="/">
              <Components.LogoImg
                src={headerLogoPath}
                // LogoImg types width/height as number; these are CSS strings
                // (e.g. '255px') passed unchanged to preserve runtime behavior.
                width={logoWidth as unknown as number}
                height={logoHeight as unknown as number}
                // APPLICATION_NAME is inferred from an untyped .js export as
                // `true | string`; coerce to string for the alt attribute.
                alt={APPLICATION_NAME as string}
              />
            </a>
            {headerText && (
              <Components.TitleText data-role="header-text">{headerText}</Components.TitleText>
            )}
          </Components.LeftWrapper>
          <Components.ChildrenContainer>{children}</Components.ChildrenContainer>
          {this.renderAvatar()}
        </Components.Header>
      </Components.Container>
    );
  }
}

export default FjGlobalHeader;
